import LoginForm from "../components/LoginForm";
import { Card } from "antd";

export default function Login() {
  return (
    <Card>
      <h3>Login</h3>
      <LoginForm />
    </Card>
  );
}
